module.exports = __webpack_public_path__ + "static/media/send-comment-button-white.4cf6322a.svg";